/**
 * @Author: v_jppjpeng
 * @Date: 2024-08-20 13:23:58
 * @Explain: 组件类
 */

export default {
  // 双因素验证
  'TWO.FACTOR.AUTH.TITLE': 'Two-Factor Authentication',
  'TWO.FACTOR.AUTH.CODE': 'Enter your 2FA code',
  'TWO.FACTOR.AUTH.CODE.DESC':
    'Retrieve your 2FA code from your authenticator app or browser extension.',
  'TWO.FACTOR.AUTH.TIPS1': 'Unable to retrieve your 2FA code?',
  'TWO.FACTOR.AUTH.TIPS2': 'Enter a backup code',
  'TWO.FACTOR.AUTH.RECOVERY.TITLE': 'Backup code verification',
  'TWO.FACTOR.AUTH.ENTER.RECOVERY.CODE': 'Enter your backup code',
  'TWO.FACTOR.AUTH.RECOVERY.TIPS1': 'Unable to use a backup code?',
  'TWO.FACTOR.AUTH.RECOVERY.TIPS2': 'Contact the SmartLink team at',
  'TWO.FACTOR.AUTH.RECOVERY.CODE.PLACEHOLDER': 'Enter your backup code',
  'TWO.FACTOR.AUTH.RECOVERY.CODE.DESC':
    'Enter one of your backup codes to verify your account',
  'TWO.FACTOR.AUTH.VERIFY': 'Verify',
  'TWO.FACTOR.AUTH.RECOVERY.VERIFY.FAIL': 'Backup code verification failed',

  // 编辑提示  v4.8 重组文案
  // 标题
  'COMMON.EDIT.TIP.TITLE':
    'Cannot make any changes, because it is actively being used in:',
  'COMMON.EDIT.TIP.QUOTE': 'is applied to',
  'COMMON.EDIT.TIP.QUOTE.THIS': 'this',
  'COMMON.EDIT.TIP.QUOTE.AND': ' ',
  'COMMON.EDIT.TIP.QUOTE.WHATSAPP':
    'with this contact field applied, the template',
  'COMMON.EDIT.TIP.QUOTE.WHATSAPP.APPROVED': 'has been approved',
  'COMMON.EDIT.TIP.QUOTE.WHATSAPP.PENDING': 'is in the of approval',
  // 模块
  'COMMON.EDIT.TIP.TYPE.PLACEHOLDER': 'Placeholder',
  'COMMON.EDIT.TIP.TYPE.SEGMENT': 'Segment',
  'COMMON.EDIT.TIP.TYPE.LABEL': 'Label',
  'COMMON.EDIT.TIP.TYPE.API': 'API',
  'COMMON.EDIT.TIP.TYPE.FORM': 'Form',
  'COMMON.EDIT.TIP.TYPE.SENDER': 'Sender',
  'COMMON.EDIT.TIP.TYPE.SENDER.ADDRESS': 'Sender address',
  'COMMON.EDIT.TIP.TYPE.SENDER.DOMAIN': 'Sender domain',
  'COMMON.EDIT.TIP.TYPE.PREFERENCE': 'Preference',
  'COMMON.EDIT.TIP.TYPE.USER.JOURNEY': 'User journey',
  'COMMON.EDIT.TIP.TYPE.TEST.PLAYER.JOURNEY': 'Test Player journey',
  'COMMON.EDIT.TIP.TYPE.USER.JOURNEY.DIALOG': 'view journey',
  'COMMON.EDIT.TIP.TYPE.REGULAR.ACTIVITY': 'Regular campaign',
  'COMMON.EDIT.TIP.TYPE.CYCLE.ACTIVITY': 'Recurring campaign',
  'COMMON.EDIT.TIP.TYPE.ABTEST.ACTIVITY': 'A/B test campaign',
  'COMMON.EDIT.TIP.TYPE.MARKET.TEMPLATE': 'Market template',
  'COMMON.EDIT.TIP.TYPE.TRANS.TEMPLATE': 'Transaction template',
  'COMMON.EDIT.TIP.TYPE.MARKET.DOUBLE.OPT': 'Double opt-in (default)',
  'COMMON.EDIT.TIP.TYPE.MARKET.CONCAT.ATTRIBUTE': 'Attribute settings',
  'COMMON.EDIT.TIP.TYPE.MARKET.CONCAT.PREFERENCE': 'Subscriber preferences',
  'COMMON.EDIT.TIP.TYPE.WHATSAPP.TEMPLATE': 'WhatsApp Template',
  // 底部跳转
  'COMMON.EDIT.TIP.BOTTOM.JUMP.DELETE.1': 'Go to ',
  'COMMON.EDIT.TIP.BOTTOM.JUMP.EDIT.1': 'Go to ',
  'COMMON.EDIT.TIP.BOTTOM.JUMP.2': ' to disconnect this link.',
  'COMMON.EDIT.TIP.BOTTOM.AND': ' and ',
  // 活动状态
  'COMMON.EDIT.TIP.ACTIVITY.DRAFT': 'Draft',
  'COMMON.EDIT.TIP.ACTIVITY.PROGRESS': 'Ongoing',
  'COMMON.EDIT.TIP.ACTIVITY.PLAN': 'Scheduled',
  'COMMON.EDIT.TIP.ACTIVITY.TEST': 'Test in progress',
  'COMMON.EDIT.TIP.ACTIVITY.APPROVAL': 'Pending approval',
  'COMMON.EDIT.TIP.ACTIVITY.PAUSE.PASSIVE': 'Pause passive',
  'COMMON.EDIT.TIP.ACTIVITY.PAUSE.MANUAL': 'Pause manual',
  'COMMON.EDIT.TIP.ACTIVITY.OVER': 'Terminated',
  'COMMON.EDIT.TIP.ACTIVITY.FINISH': 'Completed',
  'COMMON.EDIT.TIP.ACTIVITY.SEND.STOP': 'Interrupted',
  // 旅程状态
  'COMMON.EDIT.TIP.USERJOURNEY.DRAFT': 'Draft',
  'COMMON.EDIT.TIP.USERJOURNEY.ACTIVE': 'Active',
  'COMMON.EDIT.TIP.USERJOURNEY.ABNORMAL': 'Pointer suspended',
  'COMMON.EDIT.TIP.USERJOURNEY.PAUSE': 'Suspended',
  'COMMON.EDIT.TIP.USERJOURNEY.END': 'Terminated',
  // 表单状态
  'COMMON.EDIT.TIP.FORM.ACTIVE': 'Active',
  'COMMON.EDIT.TIP.FORM.UNACTIVE': 'Inactive',
  // API状态
  'COMMON.EDIT.TIP.API.ACTIVE': 'Active',
  'COMMON.EDIT.TIP.API.REVOKE': 'Inactive',
};
